import request from '@/utils/request'


//查询视频展示
export function getVideoList(query) {
  return request({
    url: '/api/websiteArticle/getVideoList',
    method: 'get',
    params: query
  })
}
//通过id查询新闻详情
export function findVideoById(query) {
  return request({
    url: '/api/websiteArticle/findVideoById',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/api/videoList.js